import CryptoJS from "crypto-js";
import { vNetGetDeviceList, vNetGetTagConfig, vNetGetTagGroups, vNetLogin, vNetUpdateTagValue } from "../../../../../../redux/slices/vNetSlice";

export const handleDoubleClick = (e, deviceType, {
    id,
    on,
    vNetUsername,
    comid,
    compvtkey,
    vNetPassword,
    key,
    dispatch,
    setLoginSid,
    setSelectedDeviceId,
    setCurrentDevice,
    setIsChangeSV,
    tempImages,
    setTempImages,
    setUpdatedImages,
    tempTabIndexIO,
    activeTabIndex,
    setUpdatedTabIndexIO,
    setTempTabIndexIO
}) => {

    const currentTime = new Date();
    // ✅ Use seconds, not milliseconds
    const ts = Math.floor(currentTime.getTime() / 1000).toString();

    // Alphabetical order: alias, comid, compvtkey, key, password, ts
    const signString = `alias=${vNetUsername}&comid=${comid}&compvtkey=${compvtkey}&key=${key}&password=${vNetPassword}&ts=${ts}`;

    console.log()

    const sign = CryptoJS.MD5(signString).toString();

    const data = {
        vNetUsername,
        vNetPassword,
        comid,
        compvtkey,
        ts,   // ✅ same ts used in sign
        sign
    };

    //login Api
    dispatch(vNetLogin(data)).then((response) => {
        if (response?.payload?.code === 200) {
            const sid = response?.payload?.result?.sid;
            setLoginSid(sid)
        }
    })

    if (id) {
        setSelectedDeviceId(id);
    }

    setCurrentDevice(deviceType);

    if (deviceType === "Controller") {

        setIsChangeSV(true);

    }
    if (deviceType === "DigitalIO") {

        const updatedTempImages = [...tempImages];
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === id
        );

        const updatedData = {
            ...updatedTempImages[originalDeviceIndex],
            on: !on
        };

        updatedTempImages[originalDeviceIndex] = updatedData;
        setTempImages(updatedTempImages);
        setUpdatedImages(updatedTempImages);

        let oldtabIndexItem = [...tempTabIndexIO[activeTabIndex]];
        const organizedDeviceIndex = oldtabIndexItem.findIndex(
            (data) => data.id === id
        );

        const newUpdatedData = {
            ...oldtabIndexItem[organizedDeviceIndex],
            on: !on
        };

        oldtabIndexItem[organizedDeviceIndex] = newUpdatedData;
        const newTempTabIndexDevices = {
            [activeTabIndex]: oldtabIndexItem,
        };

        setUpdatedTabIndexIO(newTempTabIndexDevices);
        setTempTabIndexIO(newTempTabIndexDevices);
    }
}



export const handleChangeSV = ({
    currentDevice,
    loginSid,
    comid,
    compvtkey,
    key,
    dispatch,
    deviceGroupName,
    deviceName,
    toast,
    tagGroupName,
    setIsChangeSV
}) => {

    console.log("Current Device in Change SV:", currentDevice);
    if (currentDevice === "Text") {
        const newSVValue = document.getElementById("changeSV").value;
        const currentPageRows = document.getElementById("currentPageRows").value;
        const currentPage = document.getElementById("currentPage").value;
        const tagName = document.getElementById("tagName").value;

        const currentTime = new Date();
        const currentTimeMilliseconds = currentTime.getTime();
        console.log("loginSid:", loginSid);
        // if (loginSid) {
        //     const boxesSignString = `comid=${comid}&compvtkey=${compvtkey}&sid=${loginSid}&ts=${currentTimeMilliseconds}&key=${key}`;
        //     const boxesSign = CryptoJS.MD5(boxesSignString).toString();

        //     const boxesApi = {
        //         comid: comid,
        //         compvtkey: compvtkey,
        //         ts: currentTimeMilliseconds.toString(),
        //         sign: boxesSign,
        //         sid: loginSid
        //     };

        //     // get groups and box from the v-net
        //     dispatch(getVnetBoxes(boxesApi)).then((responseBoxes) => {
        //         const boxsList = responseBoxes?.payload?.result?.list;
        //         return boxsList;
        //     }).then((boxesList) => {
        //         if (boxesList.length > 0) {
        //             const selectedCustomTag = boxesList.find((box) => box.groupName === deviceGroupName);
        //             const selectedBox = selectedCustomTag?.boxList.find((box) => box.boxName === deviceName);
        //             if (!selectedCustomTag) {
        //                 toast({
        //                     title: "Couldn't find the device group name with given name",
        //                     status: "error",
        //                     position: "top-right",
        //                     duration: 3000,
        //                     isClosable: true,
        //                 })
        //             }
        //             if (!selectedBox) {
        //                 toast({
        //                     title: "Couldn't find the box with given name",
        //                     status: "error",
        //                     position: "top-right",
        //                     duration: 3000,
        //                     isClosable: true,
        //                 })
        //             }
        //             return { selectedCustomTag, selectedBox };
        //         } else {
        //             toast({
        //                 title: "No device group are available",
        //                 status: "error",
        //                 position: "top-right",
        //                 duration: 3000,
        //                 isClosable: true,
        //             })
        //         }
        //         // throw new Error('No boxes found');
        //     }).then(({ selectedCustomTag, selectedBox }) => {
        //         // get real time tags from v-net

        //         if (selectedBox) {
        //             const realGroupSignString = `boxId=${selectedBox?.boxId}&comid=${comid}&compvtkey=${compvtkey}&sid=${loginSid}&ts=${currentTimeMilliseconds}&key=${key}`
        //             const realGroupSign = CryptoJS.MD5(realGroupSignString).toString();

        //             const realGroupApi = {
        //                 boxId: selectedBox?.boxId,
        //                 sid: loginSid,
        //                 comid: comid,
        //                 compvtkey: compvtkey,
        //                 ts: currentTimeMilliseconds,
        //                 sign: realGroupSign
        //             }

        //             dispatch(getVnetRealGroups(realGroupApi)).then((responseRealGroups) => {
        //                 const groupList = responseRealGroups?.payload?.result?.list;
        //                 if (groupList) {
        //                     const selectedGroup = groupList.find((group) => group.groupName === tagGroupName);
        //                     if (!selectedGroup) {
        //                         toast({
        //                             title: "Couldn't find tag group with given name",
        //                             status: "error",
        //                             position: "top-right",
        //                             duration: 3000,
        //                             isClosable: true,
        //                         })
        //                     }
        //                     return { selectedGroup, selectedBox }
        //                 }
        //             }).then(({ selectedGroup, selectedBox }) => {

        //                 if (selectedBox && selectedGroup) {
        //                     const realTimeTagsSignString = `boxId=${selectedBox?.boxId}&comid=${comid}&compvtkey=${compvtkey}&groupId=${selectedGroup?.groupId}&pageIndex=${currentPage}&pageSize=${currentPageRows}&sid=${loginSid}&ts=${currentTimeMilliseconds}&key=${key}`;

        //                     const realTimeTagsSign = CryptoJS.MD5(realTimeTagsSignString).toString();

        //                     const realTimeTagsApi = {
        //                         boxId: selectedBox.boxId.toString(),
        //                         groupId: selectedGroup.groupId.toString(),
        //                         pageSize: currentPageRows.toString(),
        //                         pageIndex: currentPage.toString(),
        //                         sid: loginSid,
        //                         comid: comid,
        //                         compvtkey: compvtkey,
        //                         ts: currentTimeMilliseconds.toString(),
        //                         sign: realTimeTagsSign
        //                     };

        //                     dispatch(getRealTimeTags(realTimeTagsApi)).then((responseRealTimeTags) => {
        //                         const tagList = responseRealTimeTags?.payload?.result?.list;
        //                         if (tagList) {
        //                             if (tagList.length > 0) {
        //                                 const tagInfo = tagList.find((tag) => tag.monitorName === tagName);
        //                                 if (!tagInfo) {
        //                                     toast({
        //                                         title: "Couldn't find tag with given name",
        //                                         status: "error",
        //                                         position: "top-right",
        //                                         duration: 3000,
        //                                         isClosable: true,
        //                                     })
        //                                 }
        //                                 return tagInfo;
        //                             }
        //                         }

        //                     }).then((tagInfo) => {
        //                         if (tagInfo) {
        //                             const updatedTagSignString = `comid=${comid}&compvtkey=${compvtkey}&monitorId=${tagInfo?.monitorId}&sid=${loginSid}&ts=${currentTimeMilliseconds}&value=${newSVValue}&key=${key}`;
        //                             const updatedTagSign = CryptoJS.MD5(updatedTagSignString).toString();
        //                             const updateTagApi = {
        //                                 monitorId: tagInfo?.monitorId,
        //                                 value: newSVValue,
        //                                 comid: comid,
        //                                 compvtkey: compvtkey,
        //                                 ts: currentTimeMilliseconds,
        //                                 sign: updatedTagSign,
        //                                 sid: loginSid
        //                             }

        //                             dispatch(updateTagValue(updateTagApi)).then((response) => {
        //                                 if (response.payload.code === 200) {
        //                                     toast({
        //                                         title: `Successfully updated ${tagInfo?.monitorName} tag value`,
        //                                         status: "success",
        //                                         position: "top-right",
        //                                         duration: 3000,
        //                                         isClosable: true,
        //                                     })
        //                                 }
        //                             })
        //                         }
        //                     })
        //                 }
        //             })
        //         }
        //     }).catch((error) => {
        //         console.error('Error:', error.message);
        //     });
        // } else {
        //     toast({
        //         title: "Something is wrong with V-net credentials",
        //         status: "error",
        //         position: "top-right",
        //         duration: 3000,
        //         isClosable: true,
        //     })
        // }
    }

    setIsChangeSV(false);
}

export const handleWidgetDoubleClick = async ({
    vNetUsername,
    vNetPassword,
    dispatch,
    setLoginSid,
    deviceType,
    setIsChannelUpdateModal,
}) => {
    console.log("password before hashing:", vNetPassword);

    // const vNetUsername = "854234a5028f46628cfbc5e135c2b23b";
    // const newVnetPassword = CryptoJS.MD5(vNetPassword).toString();

    const cuid = "854234a5028f46628cfbc5e135c2b23b";
    const ts = Date.now(); // milliseconds

    const allParams = {
        alias: vNetUsername,
        cuid: cuid,
        lan: "zh",
        mt: "255",
        password: vNetPassword,
        pid: "1",
        sv: "1.0",
        ts: ts.toString(),
    };

    console.log("All Params for Sign:", allParams);

    // Sort alphabetically, join, append fixed key
    const signString = Object.keys(allParams)
        .sort()
        .map(k => `${k}=${allParams[k]}`)
        .join("&") + "&key=5cee621329f24e5cbdc43daa959ce9a1";

    const sign = CryptoJS.MD5(signString).toString();

    const data = {
        vNetUsername,
        vNetPassword,
        cuid,
        ts: ts.toString(),
        sign
    }

    await dispatch(vNetLogin(data)).then((response) => {
        console.log("V-net Login Response:", response);

        // Your payload structure is different
        const res = response?.payload?.data;

        if (res?.code === 200) {
            const sid = res?.result?.sid;
            setLoginSid(sid);
        } else {
            console.log("Login failed:", res);
        }
    });

    

    if (deviceType === "Text") {
        setIsChannelUpdateModal(true);
    }
};





